import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { zValidName } from '@daymade/common-lib/validationRules';
import { z } from 'zod';

import { zodSelectPlayer } from '../generated/zodSchemas.generated';

export const ZPlayerSelectPrivate = zodSelectPlayer
  .pick({
    id: true,
    emailAddress: true,
    firstName: true,
    lastName: true,
    phoneNumber: true,
    referralId: true,
    status: true,
    role: true,
    treesPlanted: true,
    avatarLocation: true,
    friendlyName: true,
    interests: true,
    gender: true,
    dateOfBirth: true,
    utmParameters: true,
    abtestVariants: true,
    suspended: true,
    suspendedUntil: true,
    frozen: true,
    spendLimitPence: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectPlayer.shape, {
      createdAt: z.coerce.date().nullable(),
      updatedAt: z.coerce.date().nullable(),
      googleUserId: z.string().nullable().optional(),
      facebookUserId: z.string().nullable().optional(),
      appleUserId: z.string().nullable().optional(),
      dateOfBirth: z.coerce.date().nullable(),
      interests: z.array(z.string()).nullable(),
    }),
  );

export const ZPlayerSelectPrivateWithHasSocialLogin =
  ZPlayerSelectPrivate.extend({
    hasSocialLogin: z.boolean(),
  });
export type TPlayerSelectPrivateWithHasSocialLogin = z.infer<
  typeof ZPlayerSelectPrivateWithHasSocialLogin
>;

const ZPlayerUpdateBase = zodSelectPlayer
  .pick({
    firstName: true,
    lastName: true,
    phoneNumber: true,
    gender: true,
    dateOfBirth: true,
    interests: true,
    avatarLocation: true,
    friendlyName: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectPlayer.shape, {
      emailAddress: zodSelectPlayer.shape.emailAddress.email().optional(),
      dateOfBirth: z.coerce.date().nullable(),
      interests: z.array(z.string()).nullable(),
    }),
  );

export const ZPlayerUpdate = ZPlayerUpdateBase.extend({
  firstName: zValidName,
  lastName: zValidName,
}).partial();

export const ZChangePassword = z.object({
  oldPassword: z.string(),
  newPassword: z.string(),
});
